"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRateContext = exports.TaxRateItemContext = exports.CustomerContext = exports.TaxContext = void 0;
const decimal_js_1 = require("decimal.js");
const TaxModels_1 = require("./TaxModels");
const products_1 = require("@getgreenline/products");
class TaxContext {
}
exports.TaxContext = TaxContext;
/**
 * Customer context for tax rate calculations
 * Equivalent to Java's TaxRateContext.CustomerContext
 */
class CustomerContext extends TaxContext {
    constructor(context) {
        super();
        this.idType = context.idType;
        this.consumerType = context.consumerType;
    }
    isTaxExempt(taxRate) {
        if (this.idType) {
            const exemptByIdType = this.idType
                ? taxRate.exemptIdentityTypes.includes(this.idType)
                : false;
            if (exemptByIdType)
                return true;
        }
        return false;
    }
}
exports.CustomerContext = CustomerContext;
/**
 * Item context for tax rate calculations
 * Equivalent to Java's TaxRateItemContext
 */
class TaxRateItemContext extends TaxContext {
    constructor(itemContext, dollarBased) {
        super();
        // deposit fee is not a fee product
        this.applicableTaxableFeeProduct = null;
        Object.assign(this, itemContext);
        this.netSubTotal = this.adjustForDollarBased(dollarBased, itemContext.netSubTotal);
        this.netDepositFee = this.adjustForDollarBased(dollarBased, itemContext.netDepositFee);
        this.setApplicableTaxableFeeProduct();
    }
    isTaxExempt(taxRate) {
        if (this.isTaxExemptByProductType())
            return true;
        if (!!this.productType && this.productType !== products_1.ProductModels.ProductType.PRODUCT) {
            const isThisFeeProductTaxable = this.isOneOfTaxableFeeProducts(taxRate.taxableFees);
            if (!isThisFeeProductTaxable)
                return true;
        }
        return false;
    }
    isTaxExemptByProductType() {
        return this.productType
            ? TaxRateItemContext.TAX_EXEMPT_PRODUCT_TYPES.includes(this.productType)
            : false;
    }
    adjustForDollarBased(dollarBased, value) {
        const amount = new decimal_js_1.Decimal(value);
        return dollarBased ? amount : amount.dividedBy(100);
    }
    isOneOfTaxableFeeProducts(taxableFees) {
        return this.applicableTaxableFeeProduct && taxableFees.includes(this.applicableTaxableFeeProduct);
    }
    setApplicableTaxableFeeProduct() {
        switch (this.productType) {
            case products_1.ProductModels.ProductType.FEE:
                this.setApplicableTaxableFeesByFeeProduct();
                break;
            case products_1.ProductModels.ProductType.TIP:
                this.setApplicableTaxableFeesByTip();
                break;
        }
    }
    setApplicableTaxableFeesByFeeProduct() {
        switch (this.productName) {
            case products_1.ProductV2Models.SystemFeesProductNames.SHIPPING:
                this.applicableTaxableFeeProduct = TaxModels_1.TaxableFees.SHIPPING;
                break;
            case products_1.ProductV2Models.SystemFeesProductNames.SURCHARGE:
                this.applicableTaxableFeeProduct = TaxModels_1.TaxableFees.SURCHARGE;
                break;
        }
    }
    setApplicableTaxableFeesByTip() {
        switch (this.productName) {
            case products_1.ProductV2Models.SystemFeesProductNames.TIP:
                this.applicableTaxableFeeProduct = TaxModels_1.TaxableFees.TIP;
                break;
        }
    }
}
exports.TaxRateItemContext = TaxRateItemContext;
TaxRateItemContext.TAX_EXEMPT_PRODUCT_TYPES = [
    products_1.ProductModels.ProductType.GIFTCARD,
    products_1.ProductModels.ProductType.PAYMENT_FEE,
];
/**
 * Tax rate context for calculations
 * Equivalent to Java's TaxRateContext
 */
class TaxRateContext extends TaxContext {
    constructor(taxRateContext, dollarBased) {
        super();
        this.companyId = taxRateContext.companyId;
        this.locationId = taxRateContext.locationId;
        this.customerContext = new CustomerContext(taxRateContext.customerContext);
        this.itemContextList = taxRateContext.itemContextList.map(item => new TaxRateItemContext(item, dollarBased));
    }
    isTaxExempt(taxRate) {
        // empty locationIds means tax rate applies to all locations
        if (taxRate.locationIds.length > 0) {
            const locationIdFound = this.isApplicableToLocation(taxRate);
            if (!locationIdFound)
                return true;
        }
        if (this.customerContext) {
            const exemptByCustomer = this.customerContext.isTaxExempt(taxRate);
            if (exemptByCustomer)
                return true;
        }
        return false;
    }
    isApplicableToLocation(taxRate) {
        if (taxRate.locationIds.length === 0)
            return true;
        return taxRate.locationIds.some((shopId) => shopId.toString() === this.locationId.toString());
    }
}
exports.TaxRateContext = TaxRateContext;
//# sourceMappingURL=TaxRateContext.js.map